import TableCoversPage from '@/views/tableCovers/TableCoversPage'

export default function TablesScreen() {
  return <TableCoversPage />
}
